import { render } from "./Encuesta.vue?vue&type=template&id=161bb5e0&ts=true"
import script from "./Encuesta.vue?vue&type=script&lang=ts"
export * from "./Encuesta.vue?vue&type=script&lang=ts"

import "./Encuesta.vue?vue&type=style&index=0&id=161bb5e0&lang=css"

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__